import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IChatbotExamEvaluation } from "../../../Components/ChatbotExamEvaluation/IChatbotExamEvaluation";

export const ChatbotExamEvaluationSlicer = createSlice({
  name: "ChatbotExamEvaluationSlicer",
  initialState: {} as IReduxState<IChatbotExamEvaluation>,
  reducers: {
    ChatbotExamEvaluation: (state, _: PayloadAction<IChatbotExamEvaluation>) => {
      state.isLoading = true;
    },
    successChatbotExamEvaluation: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureChatbotExamEvaluation: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearChatbotExamEvaluationStatus: (state) => {
      state.data = {};
    },
  },
});

export const {
  ChatbotExamEvaluation,
  successChatbotExamEvaluation,
  failureChatbotExamEvaluation,
  clearChatbotExamEvaluationStatus,
} = ChatbotExamEvaluationSlicer.actions;

export default ChatbotExamEvaluationSlicer.reducer;
